import { render } from "./HeroiconsSolidMenuAlt2.vue?vue&type=template&id=7ce6bdfe"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMenuAlt2.vue"]])

export default __exports__